import React from "react";
import { FilterPart } from "../FilterCard";
import { sweetalert } from "../../App";
import { CustomFieldBuilder } from "../../customfields/CustomFieldBuilder";
import { useHistory, Link } from "react-router-dom";
import { Validators } from "../../validation/Validators";
import { calculateAge, isBlank, isOnlyWhitespace } from "../../util/ValidationUtil";
import Overlay from "../Overlay";
import { hideModal, buildRow, parseDate, isEighteenOrOlder, showModalNoOutsideClick, getSelectLabels, getlabelsFromIDs, getLabel } from "../../util/FormatUtil";
import InBetweenOverlay from "../InBetweenOverlay";
import Select from "react-select";
import GetField from "../../customfields/GetField";
import { isEmptyObject } from "jquery";
import { BsFillRecord2Fill } from "react-icons/bs";
import { HintModal } from "./HintModal";
import { FaInfoCircle } from "react-icons/fa";
import PhoneInput from 'react-phone-number-input'
import AutoComplete from "../admin/Autocomplete";
import CustomInput from "../form/CustomInput";
import CustomSelect from "../form/CustomSelect";
import CustomPhone from "../form/CustomPhone";
import { AiOutlineConsoleSql, AiOutlineDown, AiOutlineClose, AiOutlineUp } from "react-icons/ai";
import Validator, { ValidationEntry } from "../../validation/Validator";





interface SubmitterInfoModalProps {
    submit: (e) => void,
    attachClearStateFunc?: (func) => void
    attachClearStateFuncGuardian?: (func) => void
    states: any
    gender: any
    ethnicity: any
    race: any
    countries: any
    facilities?
    portalSubmitters?
    fromWalkin?
    fromSubmitterMgmt?
    submitterFields?
    selectedSubmitter?
}

interface SubmitterInfoModalState {
    showLoading: boolean
    showInBetween: boolean
    submitterInfo
    selectedSubmitter?
    answeredQuestions?: any
    answeredQuestionsForGetField?
    hintHeader?;
    hintContent?;
    searchAddress?
    submittedByArrowDown?: boolean
    sendReportToArrowDown?: boolean
    sameAsAbove?: boolean
}
export class SubmitterInfoModal extends React.Component<SubmitterInfoModalProps, SubmitterInfoModalState> {
    public static ID = "submitterinfo";
    constructor(props) {
        super(props);
        this.state = {
            showLoading: false,
            showInBetween: false,
            selectedSubmitter: null,
            submitterInfo: {},
            submittedByArrowDown: false,
            hintHeader: "Submitter Information Hints",
            sameAsAbove: false,
            hintContent: [
                <div style={{ fontSize: '1.5rem', marginBottom: '1rem' }}><BsFillRecord2Fill color={"#141c54"} size={25} /> Readonly submitter information can be updated via Submitter Management.</div>
            ]
        } as any;
    }



    componentWillReceiveProps(nextProps: Readonly<SubmitterInfoModalProps>, nextContext: any) {
        if (!isEmptyObject(nextProps.selectedSubmitter) && nextProps.fromSubmitterMgmt) {
            this.updateRows(nextProps.selectedSubmitter)
        }
    }


    componentDidMount(): void {
        $(`#${SubmitterInfoModal.ID}`).on('shown.bs.modal', function () {
            $(document).off('focusin.modal');
        });
    }

    handleSave() {
        this.setState({ showLoading: true })

        let validator = new Validator<any>().withValidation("sendToFirstName", Validators.requireNotBlankAndLength(50, "Send Report To First Name"));
        validator = validator.withValidation("sendToLastName", Validators.requireNotBlankAndLength(50, "Send Report To Last Name"))
        validator = validator.withComposedValidation("sendToPhone", new ValidationEntry(Validators.requireNonNullValidator("Send Report To Phone")), new ValidationEntry(Validators.requirePhone("Send Report To Phone")))
        validator = validator.withComposedValidation("sendToEmail", new ValidationEntry(Validators.requireValidEmail("Send Report To Email")), Validators.requireNotBlankAndLength(100, "Send Report To Email"))
        validator = validator.withValidation("streetAddress", Validators.requireNotBlankAndLength(500, "Send Report To Address"))
        validator = validator.withValidation("city", Validators.requireNotBlankAndLength(100, "Send Report To City"))
        validator = validator.withValidation("state", Validators.requireNotBlankAndLength(100, "Send Report To State"))
        validator = validator.withValidation("zip", Validators.requireNotBlankAndLength(100, "Send Report To Zipcode"))
        validator = validator.withValidation("submittedByFirstName", Validators.requireNotBlankAndLength(100, "Submitted By First Name"))
        validator = validator.withValidation("submittedByLastName", Validators.requireNotBlankAndLength(100, "Submitted By Last Name"))
        validator = validator.withValidation("submittedByPhone", Validators.requireNotBlankAndLength(100, "Submitted By Phone"))


        let validationResponse = validator.validate(this.state.submitterInfo);
        if (!validationResponse.success) {
            this.setState({ showLoading: false })
            return sweetalert.fire({
                icon: "error",
                title: "",
                text: validationResponse.error,
            });
        }

        this.props.submit({ submitterInfo: this.state.submitterInfo })

        hideModal(SubmitterInfoModal.ID)
        this.setState({ showLoading: false })
    }

    clearForWalkin = () => {

        this.setState({
            submitterInfo: {
                submittedByFirstName: '',
                submittedByLastName: '',
                submittedByPhone: '',
                sendToFirstName: '',
                sendToLastName: '',
                sendToPhone: '',
                sendToEmail: '',
                streetAddress: '',
                city: '',
                state: '',
                zip: '',
                phoneNumber: '',
                FacilityIDs: []
            },
            searchAddress: "",
            selectedSubmitter: null,
            sameAsAbove: false
        })
    }

    handleChange(e, stateToSet, stateLabelToSet = '', type = 'input') {
        console.log(e, "E")
        if (type === 'select') {
            this.setState((prevState) => ({
                submitterInfo: {
                    ...prevState.submitterInfo,
                    [stateLabelToSet]: e,
                    [stateToSet]: e.value,
                },
            }));

        } else if (type === 'checkbox') {
            this.setState((prevState) => ({
                submitterInfo: {
                    ...prevState.submitterInfo,
                    [stateToSet]: e,
                },
            }));
        }
        else {
            this.setState((prevState) => ({
                submitterInfo: {
                    ...prevState.submitterInfo,
                    [stateToSet]: e.target.value,
                },
            }));
        }

    }

    handleDateOnChange(value, state) {
        if (value) {
            this.setState((prevState) => ({
                submitterInfo: {
                    ...prevState.submitterInfo,
                    [state]: value,
                },
            }));
        } else {
            this.setState((prevState) => ({
                submitterInfo: {
                    ...prevState.submitterInfo,
                    [state]: null,
                },
            }));
        }
    }


    async updateRows(e) {
        if (!e) {
            this.setState({ submitterInfo: {}, selectedSubmitter: null })
            return;
        }
        this.setState({ selectedSubmitter: e, submitterInfo: {} })
        let submitterPortalInfo = e ? await this.props.portalSubmitters.find(p => p.id === e.value) : null;
        let tempObj = {};
        let over18 = true;

        // Define a mapping configuration object
        const fieldMapping = {
            firstName: 'First Name',
            lastName: 'Last Name',
            dateOfBirth: 'Date of Birth',
            middleName: 'Middle Name',
            email: 'Email',
            streetAddress: 'Address',
            streetAddress2: 'Address Cont.',
            city: 'City',
            state: 'State',
            zipcode: 'Zipcode',
            country: 'Country',
            county: 'County',
            ethnicityID: 'Ethnicity',
            genderID: 'Gender',
            raceID: 'Race',
            guardianFirstName: 'Guardian First Name',
            guardianLastName: 'Guardian Last Name',
            phoneNumber: 'Phone',
            FacilityIDs: 'FacilityIDs'
        };

        const otherKeys = ['uid']

        try {
            if (submitterPortalInfo) {
                for (const key of Object.keys(submitterPortalInfo)) {
                    if (this.props.fromSubmitterMgmt && key === 'FacilityIDs') {
                        tempObj[key] = JSON.parse(submitterPortalInfo[key])
                    }
                    if (otherKeys.includes(key)) {
                        tempObj[key] = submitterPortalInfo[key];
                        continue;
                    }
                    if (key === 'firstName' || key === 'lastName') {
                        tempObj[fieldMapping[key]] = submitterPortalInfo[key];
                        continue;
                    }

                    if (key === 'dateOfBirth') {
                        tempObj[fieldMapping[key]] = submitterPortalInfo[key];
                        over18 = isEighteenOrOlder(submitterPortalInfo[key])
                        continue;
                    }
                    if (key !== 'firstName' && key !== 'lastName' && key !== 'dateOfBirth' && !otherKeys.includes(key)) {
                        if (key.toLowerCase().includes('guardian') && over18) {
                            continue;
                        }
                        let matchingElement = this.props.submitterFields.find(f => f.DisplayName === fieldMapping[key]);
                        if (matchingElement && !isEmptyObject(matchingElement) && matchingElement.Options.isActive) {
                            if (key === 'ethnicityID') {
                                tempObj[fieldMapping[key]] = submitterPortalInfo[key] ? this.props.ethnicity.find(f => f.value === submitterPortalInfo[key]).label : null;
                                continue;
                            }
                            if (key === 'raceID') {
                                tempObj[fieldMapping[key]] = submitterPortalInfo[key] ? this.props.race.find(f => f.value === submitterPortalInfo[key]).label : null;
                                continue;
                            }
                            if (key === 'genderID') {
                                tempObj[fieldMapping[key]] = submitterPortalInfo[key] ? this.props.gender.find(f => f.value === submitterPortalInfo[key]).label : null;
                                continue;
                            }
                            if (key === 'state') {
                                tempObj[fieldMapping[key]] = submitterPortalInfo[key] ? this.props.states.find(f => f.value === submitterPortalInfo[key]).label : null;
                                continue;
                            }
                            if (key === 'country') {
                                tempObj[fieldMapping[key]] = submitterPortalInfo[key] ? this.props.countries.find(f => f.value === submitterPortalInfo[key]).label : null;
                                continue;
                            }
                            tempObj[fieldMapping[key]] = submitterPortalInfo[key];

                        }
                    }
                }
                if (submitterPortalInfo.CustomFieldData && !isEmptyObject(JSON.parse(submitterPortalInfo.CustomFieldData))) {
                    let parsedCustomFieldData = JSON.parse(submitterPortalInfo.CustomFieldData)
                    for (const key of Object.keys(parsedCustomFieldData)) {
                        tempObj[key] = parsedCustomFieldData[key]
                    }
                }
            }
        } catch (error) {
            console.error(error)
            return sweetalert.fire({ icon: 'error', title: '', text: 'Could not update rows at this time' })
        }

        this.setState((prevState) => {
            const updatedSubmitterInfo = { ...prevState.submitterInfo };
            if (isEmptyObject(updatedSubmitterInfo)) {
                updatedSubmitterInfo.CustomFieldData = {};
            }
            for (const key in tempObj) {
                if (tempObj.hasOwnProperty(key)) {
                    updatedSubmitterInfo.CustomFieldData[key] = tempObj[key];
                }
            }
            return {
                submitterInfo: updatedSubmitterInfo,
            };
        })
    }

    render() {

        // console.log('SubmitterInfoModal props', this.props)
        // console.log('SubmitterInfoModal state', this.state)

        let over18 = this.state.submitterInfo && this.state.submitterInfo.CustomFieldData && this.state.submitterInfo.CustomFieldData['Date of Birth'] ? isEighteenOrOlder(this.state.submitterInfo.CustomFieldData['Date of Birth']) : true;

        return (
            <React.Fragment>
                <Overlay show_loading={this.state.showLoading} zIndex={100005} />
                <InBetweenOverlay showInBetween={this.state.showInBetween} zIndex={100003} />
                <HintModal
                    zIndex={100006}
                    handleInBetweenOverlay={() => this.setState({ showInBetween: false })}
                    header={this.state.hintHeader}
                    content={this.state.hintContent}
                />
                <div className="modal fade form_modal" id={SubmitterInfoModal.ID} aria-modal={true} tabIndex={-1} role="dialog"
                    aria-label="Submitter Information"
                    aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-body p-0 m-0">
                                <div className="container-fluid">
                                    <div className={"row"}>
                                        <div className="col-12 pt-2">
                                            <div className="card mt-2">
                                                <div className="card-header verlag-bold">
                                                    <div className="row">
                                                        <div className="col-10">
                                                            <h4>
                                                                Submitter Information
                                                            </h4>
                                                        </div>
                                                        <div className="col-2">
                                                            <button style={{ outline: 'none' }} type="button" className="close pr-4"
                                                                aria-label="Close" onClick={() => hideModal(SubmitterInfoModal.ID)}>
                                                                <span aria-hidden="true" style={{ fontSize: '1.5em', fontWeight: 'bold' }}>&times;</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="card-body">





                                                    <div className="card mb-2">
                                                        <button className="card-header verlag-bold accordionButton w-100" data-toggle="collapse" data-target="#walkinSampleInfoCollapse" onClick={() => this.setState({ submittedByArrowDown: !this.state.submittedByArrowDown })} aria-expanded="false" aria-controls="walkinSampleInfoCollapse">
                                                            <div className="row d-flex justify-content-between">
                                                                <div className="ml-2">
                                                                    <h4>Submitted By</h4>
                                                                </div>
                                                                <div className="col-2">
                                                                    {this.state.submittedByArrowDown ? (<AiOutlineUp className={'float-right'} size={30} data-toggle="collapse" data-target="#walkinSampleInfoCollapse" role="button" aria-expanded="false" aria-controls="walkinSampleInfoCollapse" />) : (<AiOutlineDown className={'float-right'} size={30} data-toggle="collapse" data-target="#walkinSampleInfoCollapse" role="button" aria-expanded="false" aria-controls="walkinSampleInfoCollapse" />)}
                                                                </div>
                                                            </div>
                                                        </button>
                                                        <div className="card-body collapse show" id={'walkinSampleInfoCollapse'}>
                                                            <CustomInput fromFilterPage={false} required={true} value={this.state.submitterInfo?.submittedByFirstName} label={"First Name"} tooltip={"First Name of individual that submitted sample"} handleChange={(e) => this.handleChange(e, 'submittedByFirstName')} maxLength={50} />
                                                            <CustomInput fromFilterPage={false} required={true} value={this.state.submitterInfo?.submittedByLastName} label={"Last Name"} tooltip={"Last Name of individual that submitted sample"} handleChange={(e) => this.handleChange(e, 'submittedByLastName')} maxLength={50} />
                                                            <CustomPhone fromFilterPage={false} required={true} value={this.state.submitterInfo?.submittedByPhone} label={"Phone"} tooltip={`The phone number of individual that submitted sample`} handleDateOnChange={(e) => this.handleDateOnChange(e, "submittedByPhone")} />
                                                        </div>
                                                    </div>
                                                    <div className="card mb-2">
                                                        <button className="card-header verlag-bold accordionButton w-100" data-toggle="collapse" data-target="#walkinSampleInfoCollapse" onClick={() => this.setState({ sendReportToArrowDown: !this.state.sendReportToArrowDown })} aria-expanded="false" aria-controls="walkinSampleInfoCollapse">
                                                            <div className="row d-flex justify-content-between">
                                                                <div className="ml-2">
                                                                    <h4>Send Report To</h4>
                                                                </div>
                                                                <div className="col-2">
                                                                    {this.state.sendReportToArrowDown ? (<AiOutlineUp className={'float-right'} size={30} data-toggle="collapse" data-target="#walkinSampleInfoCollapse" role="button" aria-expanded="false" aria-controls="walkinSampleInfoCollapse" />) : (<AiOutlineDown className={'float-right'} size={30} data-toggle="collapse" data-target="#walkinSampleInfoCollapse" role="button" aria-expanded="false" aria-controls="walkinSampleInfoCollapse" />)}
                                                                </div>
                                                            </div>
                                                        </button>
                                                        <div className="card-body collapse show" id={'walkinSampleInfoCollapse'}>
                                                            <div className="form-group row">
                                                                <div className={"col-12 col-md-4"}>
                                                                </div>
                                                                <div className="col-sm-8 d-flex justify-content-center p-0 m-0" id={'SearchAddress'}>
                                                                    <div className="mt-2 form-check">
                                                                        <span className={"form-check-label"}>
                                                                            <input className={"form-check-input"}
                                                                                type="checkbox" id="sameAsAbove"
                                                                                aria-label="Same as above"
                                                                                onChange={(e) => {
                                                                                    this.setState({
                                                                                        sameAsAbove: e.target.checked,
                                                                                        submitterInfo: {
                                                                                            ...this.state.submitterInfo,
                                                                                            sendToFirstName: e.target.checked ? this.state.submitterInfo?.submittedByFirstName : "",
                                                                                            sendToLastName: e.target.checked ? this.state.submitterInfo?.submittedByLastName : "",
                                                                                            sendToPhone: e.target.checked ? this.state.submitterInfo?.submittedByPhone : "",
                                                                                        }
                                                                                    })
                                                                                }}
                                                                                checked={this.state.sameAsAbove}
                                                                            /> Same as Above
                                                                        </span>
                                                                        {/* <label htmlFor="rememberMe" className="form-label">Remember Me</label> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <CustomInput fromFilterPage={false} required={true} value={this.state.sameAsAbove ? this.state.submitterInfo?.submittedByFirstName : this.state.submitterInfo?.sendToFirstName} label={"First Name"} tooltip={"First Name of individual that submitted sample"} handleChange={(e) => this.handleChange(e, 'sendToFirstName')} maxLength={50} />
                                                            <CustomInput fromFilterPage={false} required={true} value={this.state.sameAsAbove ? this.state.submitterInfo?.submittedByLastName : this.state.submitterInfo?.sendToLastName} label={"Last Name"} tooltip={"Last Name of individual that submitted sample"} handleChange={(e) => this.handleChange(e, 'sendToLastName')} maxLength={50} />
                                                            <CustomPhone fromFilterPage={false} required={true} value={this.state.sameAsAbove ? this.state.submitterInfo?.submittedByPhone : this.state.submitterInfo?.sendToPhone} label={"Phone"} tooltip={`The phone number of individual that submitted sample`} handleDateOnChange={(e) => this.handleDateOnChange(e, "sendToPhone")} />
                                                            <CustomInput fromFilterPage={false} required={true} value={this.state.submitterInfo?.sendToEmail} label={"Email"} tooltip={"Email of individual that submitted sample"} handleChange={(e) => this.handleChange(e, 'sendToEmail')} maxLength={50} />

                                                            <div className="form-group row">
                                                                <div
                                                                    className={"col-12 col-md-4"}
                                                                    data-toggle={"tooltip"}
                                                                    data-placement={"top"}
                                                                    title={"Search Address"}
                                                                >
                                                                    <label
                                                                        htmlFor={'SearchAddress'}
                                                                        style={{ fontWeight: "bold", paddingTop: "0.5em", fontSize: "0.8em" }}
                                                                        aria-label={"Search Address"}
                                                                    >
                                                                        {"Search Address"}
                                                                    </label>
                                                                </div>
                                                                {/* <label htmlFor={'SearchAddress'} style={{ fontWeight: "bold", paddingTop: "0.5em", fontSize: "0.8em" }} className="col-sm-4 col-form-label">Search Address</label> */}
                                                                <div className="col-sm-8  p-0 m-0" id={'SearchAddress'}>
                                                                    <AutoComplete key={"Exposureautocomplete"} id={"Exposureautocomplete"}
                                                                        onChange={(addr) => {
                                                                            this.setState((prevState) => ({ searchAddress: addr }))
                                                                        }}
                                                                        value={this.state.searchAddress}
                                                                        updateFormData={(addr, addr2, city, state, zip, county, country) => {
                                                                            console.log(addr, city, state, zip)
                                                                            let addressData = { streetAddress: "", city: "", state: {}, zip: "" }
                                                                            addressData.streetAddress = addr;
                                                                            addressData.city = city;
                                                                            addressData.state = state;
                                                                            addressData.zip = zip;
                                                                            this.setState({ submitterInfo: { ...this.state.submitterInfo, ...addressData } })
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <CustomInput fromFilterPage={false} required={true} value={this.state.submitterInfo?.streetAddress} label={"Street Address"} tooltip={"Street Address"} handleChange={(e) => this.handleChange(e, 'streetAddress')} maxLength={100} />
                                                            <CustomInput fromFilterPage={false} required={true} value={this.state.submitterInfo?.city} label={"City"} tooltip={"City"} handleChange={(e) => this.handleChange(e, 'city')} maxLength={100} />
                                                            <CustomSelect fromFilterPage={false} required={true} value={this.state.submitterInfo.state ? getLabel(this.state.submitterInfo.state, this.props.states) : null} label={"State"} tooltip={"State"} handleChange={(e) => this.handleChange(e, "state", "stateLabel", "select")} options={this.props.states} />
                                                            <CustomInput fromFilterPage={false} required={true} value={this.state.submitterInfo?.zip} label={"Zip"} tooltip={"Zip"} handleChange={(e) => this.handleChange(e, 'zip')} maxLength={50} />
                                                        </div>
                                                    </div>
                                                    {/* {this.props.submitterFields && this.props.submitterFields.length > 0 && this.props.submitterFields.map((val, index) => {
                                                            if (val.Options.isActive) {

                                                                if (over18 && val.DisplayName.toLowerCase().includes('guardian')) {
                                                                    return <div className="d-none"></div>
                                                                }
                                                                return (
                                                                    <>
                                                                        {val.ID === 30 ?
                                                                            <div className="col-12">
                                                                                <div className="form-group row">
                                                                                    <label htmlFor={'SearchAddress'} className="col-sm-4 col-form-label">Search Address</label>
                                                                                    <div className="col-sm-8  p-0 m-0" id={'SearchAddress'}>
                                                                                        <AutoComplete key={"Exposureautocomplete"} id={"Exposureautocomplete"}
                                                                                            onChange={(addr) => {
                                                                                                this.setState((prevState) => ({ searchAddress: addr }))
                                                                                            }}
                                                                                            value={this.state.searchAddress}
                                                                                            updateFormData={(addr, addr2, city, state, zip, county, country) => {
                                                                                                console.log(addr, city, state, zip)
                                                                                                let addressData = {Address: "", City: "", State: {}, Zipcode: ""}
                                                                                                addressData.Address = addr;
                                                                                                addressData.City = city;
                                                                                                addressData.State = {answer: getLabel(state, this.props.states).label, serviceType: null};
                                                                                                addressData.Zipcode = zip;
                                                                                                this.setState({ submitterInfo: { ...this.state.submitterInfo, CustomFieldData: {...this.state.submitterInfo.CustomFieldData, ...addressData} } })
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div> :
                                                                            <></>
                                                                        }
                                                                        
                                                                    </>
                                                                );
                                                            }
                                                        })} */}


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-footer" style={{ backgroundColor: 'transparent', borderTop: 'none' }}>
                                        <button className={"btn btn-primary float-right mb-3"} onClick={() => this.handleSave()}>Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </React.Fragment>
        )
    }

}